module.exports = __webpack_public_path__ + "img/expovina-primavera_03.7d3f1476.jpg";